<template>
<div class="menu" v-if="NavLength != 0">
    <a id="imageAnchor" href="javascript:;" onclick="this.focus()" @blur="closeMenu">
        <div class="burgerbar" @click="menuOpen">
            <div></div>
            <div></div>
            <div></div>
        </div>        
        <div class="popover" :class="{ active: isShowing }">
            <div class="element" v-for="(p, i) in NavPoints" :key="p.id" @mousedown="onClick(p)" :class="{spacer: (p.spacer && i)}"><span class="icon" :class="p.icon"></span>{{$t(p.label)}}</div>
        </div>
    </a>
</div>
</template>

<script>

import { mapGetters, mapMutations, mapActions } from 'vuex';
import glMut from '../store/mutations/global';
import compMut from '../store/mutations/competition';
import glAct from '../store/actions/global';
import navMut from '../store/mutations/navigation';
import setMut from '../store/mutations/settings';

export default {
	name: 'Navigation',
	data() {
		return {
			isShowing: false,
			isClosing: false,
		};
	},
	methods: {
        ...mapMutations([
            glMut.LOGOUT,
            glMut.UNSETHEATDATA,        
            glMut.SETWKBHELP,
            compMut.LOGOUT,
            navMut.HIDEALLNAVPOINT,
            setMut.SETLANG,
        ]),
        ...mapActions([
            glAct.SETHEATGROUPSTATUS,            
            glAct.REQUESTPOOLMERGEAVAILABLE
        ]),
		menuOpen() {
			this.isShowing = !this.isShowing;
		},
		closeMenu() {
            this.$nextTick(() => {                
                this.isShowing = false;
            });
        },
        onClick(p){
            p.call(this);
            this.$nextTick(() => {                
                this.isShowing = false;
            });
        }
	},
	computed: {
        ...mapGetters(['NavPoints', 'NavLength', 'LocaleFallBack'])
    },
    mounted(){
        // console.log(this.NavPoints);
    }
};
</script>

<style lang="scss" scoped>

    @import "../../assets/styles/_globals";

    .menu {
        width: $height_default - 16;
        margin-right:auto;
        cursor: pointer;
        padding-left: 10px;

        display: flex;
        align-items: center;

        .burgerbar {
            div {
                height:3px;
                margin-bottom:6px;
                background-color:$font-light-color;
            }

            div:last-of-type {
                margin-bottom: 0px;
            }
        }   
        a {
            width: $height_default;
            outline: none;
        }     
        a>div:first-of-type:hover {
            background-color: $prim_shadow_color;
        }
    }

    .popover {
        min-width: 150px;
        padding:10px 0px;
        position: absolute;
        opacity: 0;     
        display:none;
        left:0;
        top: ($height_mid + 2px);
        border-right: solid 1px $sec_color_dark;
        background-color: $prim_bg_color;
        height: calc(100vh - (#{$height_mid} + 2px));
        box-sizing: border-box;
        color:$font-light-color;
        z-index: 10;
    }

    .active {  
        display:block;    
        animation:fadeIn 300ms forwards;
    }

    .element {        
        padding:10px;
        overflow: hidden;

        .icon {
            font: normal normal normal 20px/1 "Material Design Icons";
            padding-right:10px;
        }

        .logout::before {
            content: "\F0343";
        }

        .help::before {
            content: "\F0C8A";
        }

        .overview::before {
            content: "\F0DD0";
        }

        .start::before {
            content: "\F040B";
        }

        .stop::before {
            content: "\F023C";
        }

        .entrants::before {
            content: "\F0849";
        }
        .merge::before {
            content: "\F00F8";
        }

        .settings::before {
            content: "\F08BB";
        }

        .entrie::before {
            content: "\F0004";
        }
    }

    .spacer {
        border-top: solid 2px $zebra-dark;
        margin-top: 3px;
        padding-top: 13px;
    }

    .element:hover, .elemnt:active {
        background-color:$sec_color_dark;
        cursor: pointer;
    }

    @keyframes fadeIn {
        0% {            
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }


</style>
